import request from "@/utils/request"

// 实时温度
export function getRoomShowave(projectUuid){
    return request({
        url: '/currentBigScreen/getRoomShowave',
        method: 'get',
        params: {
            projectUuid
        }
    })
}
// 能耗组成占比
export function getEnergyProportion(projectUuid) {
    return request({
        url: '/currentBigScreen/getEnergyProportion',
        method: 'get',
        params: {
            projectUuid
        }
    })
}
export function getEnergyChange(projectUuid) {
    return request({
        url: '/currentBigScreen/getEnergyChange',
        method: 'get',
        params: {
            projectUuid
        }
    })
}
// 冷间面积分布
export function getRoomArea(projectUuid) {
    return request({
        url: '/currentBigScreen/getRoomArea',
        method: 'get',
        params: {
            projectUuid
        }
    })
}
// 获取冷间运行时长
export function getRoomRunTime(projectUuid) {
    return request({
        url: '/currentBigScreen/getRoomRunTime',
        method: 'get',
        params: {
            projectUuid
        }
    })
}
// 查询项目城市当前温度湿度
export function getProjectWeatherData(projectUuid) {
    return request({
        url: '/currentBigScreen/getProjectWeatherData',
        method: 'get',
        params: {
            projectUuid
        }
    })
}
// // 大屏简介
// export function getBriefIntroduction() {
//     return request({
//         url: '/currentBigScreen/getBriefIntroduction',
//         method: 'get',
//     })
// }